<template>
  <div class="container-fluid hv-100">
    <div class="row justify-content-center h-100">
      <!-- Form -->
      <div class="col-12 bg-white mx-0 px-0 d-flex flex-row align-items-center"
        :class="{ 'col-lg-7': !calledFromAdmin }">
        <div class="col-12" :class="{
            'col-md-8 offset-md-2': !calledFromAdmin,
            'px-4': calledFromAdmin,
          }">
          <div class="wrapper-form" v-if="emailSent() && showVerificationCode">
            <div class="my-2 py-0">
              <h3 class="text-lg-left my-1">
                <span class="font-weight-bold">
                  {{ $t("lang.label.verificationcode") }}</span>
              </h3>
              <p id="codeHelp" class="form-text small">
                {{ $t("lang.label.insertthecodethatyoureceivedbyemail") }}
              </p>
            </div>
            <div class="mt-4 ml-1">
              <div class="form-row my-3">
                <label for="">{{ $t("lang.label.insertcode") }}</label>
                <input id="code" type="text" class="form-control" v-model="code" required="true" />
                <div class="col-12" v-if="codeSent">
                  <span class="mt-2 mr-2 mb-4">
                    {{ $t("lang.label.login-code-sent") }}
                  </span>
                  <img src="@/assets/images/icons_login/zorro-icon.png" class="icon-zorro" />
                </div>
                <div class="col-12" v-if="alert.message && !submittedCodeSecond" :class="`mt-1 alert ${alert.type}`">
                  {{ alert.message }}
                </div>
                <div class="col-12" v-if="submittedCodeSecond && alert.message">
                  <div class="mt-1">
                    <AlertError :msgError="alert.message" />
                  </div>
                </div>
                <div class="col-md-12 mt-3 px-0">
                  <div class="row mx-0">
                    <div class="col-sm-12 col-md-6 pl-0 pr-1 mx-0">
                      <button class="btn btn-ligth btn-block border border-primary text-primary mt-2"
                        @click="resendVerificationCode()">
                        {{ $t("lang.label.resendcode") }}
                      </button>
                    </div>
                    <div class="col-sm-12 col-md-6 pl-1 pr-0 mx-0">
                      <button class="btn btn-primary btn-block mt-2" @click="checkVerificationCode">
                        {{ $t("lang.button.submitcode") }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center mr-3">
                <router-link class="ml-3" to="/login">
                  {{ $t("lang.button.logout") }}
                </router-link>
              </div>
            </div>
          </div>
          <div class="wrapper-form" v-if="!emailSent()">
            <div v-if="hash != null">
              <h4>{{ $t("lang.label.createteamaccount") }}</h4>
            </div>
            <div class="my-0" v-else>
              <div class="my-1">
                <div class="d-flex align-items-center">
                  <h4 class="font-weight-bold mr-3">
                    {{ $t("lang.label.booker-login-create") }}
                  </h4>
                </div>
                <small>{{ $t("lang.label.booker-login-b2b") }}</small>
              </div>
            </div>
            <form class="pt-0 mt-0" v-on:submit.prevent="handleSubmit">
              <!-- Field Email -->
              <div class="form-row my-0">
                <label for="" class="ml-1 my-1">{{
                  $t("lang.label.email")
                  }}</label>
                <div class="form-group col-md-12 my-0">
                  <input id="email" type="email"
                    :title="$t('lang.accountcreation.email')" class="form-control" v-model="username" required="true" />
                  <!-- <small id="emailHelp" class="form-text dark-gray">{{
                    $t("lang.label.youwillhavetoconfirmthatthisemailisyours")
                    }}</small> -->
                </div>
              </div>              
              <!-- Field Firstname and lastname -->
              <div class="form-row my-2">
                <div class="col-sm-12 col-md-6 my-1">
                  <label for="" class="ml-1 mb-2">{{
                    $t("lang.label.firstname")
                    }}</label>
                  <input id="firstname" type="text" class="form-control" v-model="firstname" required="true" />
                </div>
                <div class="col-sm-12 col-md-6 my-1">
                  <label for="" class="ml-1 mb-2">{{
                    $t("lang.label.lastname")
                    }}</label>
                  <input id="lastname" type="text" class="form-control" v-model="lastname" required="true" />
                </div>
              </div>
              <!-- Field Language -->
              <div class="form-row my-2 px-0">
                <div class="col-md-12">
                  <label for="" class="ml-1 my-1">{{
                    $t("lang.label.language")
                    }}</label>
                  <div class="input-group my-1 mx-0 px-0">
                    <span class="input-group-text px-1 mr-2">
                      <img :src="flag" class="flag" />
                    </span>
                    <select v-model="language_id" class="form-control text-secondary py-0 my-0" required="true">
                      <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang.id">
                        {{ lang.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Field phone -->
              <div class="form-row my-2 px-0">
                <div class="col-12">
                  <label for="" class="ml-1 my-1">{{
                    $t("lang.label.mobile_phone")
                    }}</label>
                  <div class="input-group my-0 mx-0 px-0">
                    <button type="button" @click="showFlag = true" class="btn btn-light px-0 py-0 my-0 mx-0"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <span class="input-group-text px-1">
                        <img :src="flagActually" class="flag ml-0 mr-2" />
                        + {{ country_id.phone_code }}
                      </span>
                    </button>
                    <div class="dropdown-menu dropdown-menu-left">
                      <button v-for="(country, i) of countriesFiltered.filter(
                          (e) => e.visible
                        )" class="dropdown-item" type="button" @click="changeCountry(country.id)" :key="i">
                        <img :src="flag2(country.id)" class="flag2" />
                        <span class="ml-2 small">+ {{ country.phone_code }} {{ country.name }}</span>
                      </button>
                      <div class="col-12 px-4 py-2">
                        <span>Other country</span>
                        <input class="my-1 border" placeholder="Your country..." type="text" v-model="filterCountry" />
                      </div>
                    </div>
                    <input id="phone" type="number" class="form-control ml-2" v-model="phone" required="true" />
                  </div>
                </div>
              </div>

              
              <!-- Field How did you meet us -->
              <div class="form-row my-2">
                <div class="col-sm-12 col-md-12">
                  <label for="user_bdr_origin_id" class="ml-1 my-1">
                    {{ $t("lang.label.how_did_you") }}
                  </label>
                  <div class="input-group my-1">
                    <select class="form-control" name="user_bdr_origin_id" id="user_bdr_origin_id"
                      v-model="user_bdr_origin_id" required="true">
                      <option value="1" key="1">{{ $t("lang.label.recommendation") }}</option>
                      <option value="2" key="2">{{ $t("lang.label.facebook") }}</option>
                      <option value="3" key="3">{{ $t("lang.label.linkedin") }}</option>
                      <option value="4" key="4">{{ $t("lang.label.universite_catholique_madagascar") }}</option>
                      <option value="5" key="5">{{ $t("lang.label.project_pair") }}</option>
                      <option value="6" key="6">{{ $t("lang.label.other") }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Field Country -->
              <div class="form-row my-2">
                <div class="col-sm-12 col-md-12">
                  <label for="country_id" class="ml-1 my-1">
                    {{ $t("lang.label.country") }}
                  </label>
                  <div class="input-group my-1">
                    <select class="form-control" name="country_id_selected" id="country_id_selected"
                      v-model="country_id_selected" required="true">
                      <option value="">Select Country</option>
                      <option
                        v-for="country in countriesSelected"
                        :key="country.id"
                        :value="country.id"
                      >
                        {{ country.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Field Url -->
              <div class="form-row my-2">
                <div class="col-sm-12 col-md-12">
                  <label for="working_hours_availability" class="ml-1 my-1">
                    {{ $t("lang.label.booker-login-hours") }}
                  </label>
                  <div class="input-group my-1">
                    <select class="form-control" name="working_hours_availability" id="working_hours_availability"
                      v-model="working_hours_availability" required="true">
                      <option value="full_time" key="full_time">{{ $t("lang.label.full_time") }}</option>
                      <option value="morning_part_time" key="morning_part_time">{{ $t("lang.label.morning_part_time") }}</option>
                      <option value="afternoon_part_time" key="afternoon_part_time">{{ $t("lang.label.afternoon_part_time") }}</option>
                    </select>
                  </div>
                  <label for="has_bank_account" class="ml-1 my-1">
                    {{ $t("lang.label.booker-login-bankaccount") }}
                  </label>
                  <div class="input-group my-1">
                    <select class="form-control" name="has_bank_account" id="has_bank_account" v-model="has_bank_account">
                      <option value="1" key="1">Oui</option>
                      <option value="0" key="0">Non</option>
                    </select>
                  </div>
                  <label for="has_internet" class="ml-1 my-1">
                    {{ $t("lang.label.booker-login-internet") }}
                  </label>
                  <div class="input-group my-1">
                    <select class="form-control" name="has_internet" id="has_internet" v-model="has_internet">
                      <option value="1" key="1">Oui</option>
                      <option value="0" key="0">Non</option>
                    </select>
                  </div>
                  <label for="has_computer" class="ml-1 my-1">
                    {{ $t("lang.label.booker-login-computer") }}
                  </label>
                  <div class="input-group my-1">
                    <select class="form-control" name="has_computer" id="has_computer" v-model="has_computer">
                      <option value="1" key="1">Oui</option>
                      <option value="0" key="0">Non</option>
                    </select>
                  </div>

                </div>
              </div>
              <!-- Field Password -->
              <div class="form-row my-2">
                <div class="form-group col-md-6 my-1">
                  <label for="" class="ml-1 mb-2">{{
                    $t("lang.label.password")
                    }}</label>
                  <input type="password" class="form-control" id="password" v-model="password" required
                    :title="$t('lang.validation.password')" required="true" />
                  <!-- <small class="form-text dark-gray">{{
                        $t("lang.validation.password")
                      }}</small> -->
                </div>
                <div class="form-group col-md-6 my-1">
                  <label for="" class="ml-1 mb-2">{{
                    $t("lang.label.confirmpassword")
                    }}</label>
                  <input type="password" pattern=".{8,}" required title="8 characters minimum" v-model="confirmpass"
                    class="form-control" id="confirmpass" required="true" />
                </div>

                <div class="form-group col-12" v-if="referred">
                  {{ $t("lang.label.codepromo") }}
                  <input type="text" v-model="referred" class="form-control" disabled />
                </div>
                <!-- <div v-if="alert.message && !submittedDataSecond" :class="`alert ${alert.type}`">
                  {{ alert.message }}
                </div> -->
                <!-- <div v-if="submittedDataSecond && alert.message">
                  <div class="mt-4">
                    <AlertError :msgError="alert.message" />
                  </div>
                </div> -->

                <!-- muestra los posibles errores del checkform -->
                <div class="my-2" v-if="submittedDataSecond || alert.message">
                  <AlertError :msgError="alert.message" />
                </div>
              </div>

              <div class="mt-2" v-if="password">
                <small>
                  <span class="ml-1" :class="{
                      'text-secundary': !validatePassword.long,
                      'text-success': validatePassword.long,
                    }">
                    <i v-if="validatePassword.long" class="icon-checkmark ml-1"></i>
                    <span v-else class="ml-3"></span>
                    <span class="ml-1">{{
                      $t("lang.label.login-pass-beetween")
                      }}</span>
                  </span>
                  <span class="ml-1" :class="{
                      'text-secundary': !validatePassword.uppercase,
                      'text-success': validatePassword.uppercase,
                    }">
                    <i v-if="validatePassword.uppercase" class="icon-checkmark ml-1"></i>
                    <span v-else class="ml-3"></span>
                    <span class="ml-1">{{
                      $t("lang.label.login-pass-uppercase")
                      }}</span>
                  </span>
                  <span class="ml-1" :class="{
                      'text-secundary': !validatePassword.lowercase,
                      'text-success': validatePassword.lowercase,
                    }">
                    <i v-if="validatePassword.lowercase" class="icon-checkmark ml-1"></i>
                    <span v-else class="ml-3"></span>
                    <span class="ml-1">{{
                      $t("lang.label.login-pass-lowercase")
                      }}</span>
                  </span>
                  <span class="ml-1" :class="{
                      'text-secundary': !validatePassword.number,
                      'text-success': validatePassword.number,
                    }">
                    <i v-if="validatePassword.number" class="icon-checkmark ml-1"></i>
                    <span v-else class="ml-3"></span>
                    <span class="ml-1">{{
                      $t("lang.label.login-pass-number")
                      }}</span>
                  </span>
                </small>
              </div>
              <!-- TERMS AND CONDITIONS TEMPORALLY BLOCKED -->
              <!-- <div v-if="!calledFromAdmin" class="mt-3">
                <div class="form-check">
                  <input class="form-check-input" :class="{ 'is-invalid': checkPolicy === false }" type="checkbox"
                    value="" id="invalidCheck3" aria-describedby="invalidCheck3Feedback" v-model="checkPolicy" />
                  <label class="form-check-label" for="invalidCheck3">
                    I agreee to the Oliverlist
                    <a class="text-primary" href="https://oliverlist.com/terms-of-services/" target="_blank">{{
                      $t("lang.label.termsofuse") }}
                    </a>
                  </label>
                </div>
                <div class="form-check mt-2">
                  <input class="form-check-input" :class="{ 'is-invalid': checkAgree === false }" type="checkbox"
                    value="" id="invalidCheck3" v-model="checkAgree" />
                  <label class="form-check-label" for="invalidCheck3">
                    I understand that my account information will be used
                    according to Oliverlist
                    <a class="text-primary" href="https://oliverlist.com/privacy-policy/" target="_blank">{{
                      $t("lang.label.privacypolicy") }}.</a>
                  </label>
                </div>
              </div> -->
              <!-- Button register -->
              <div class="d-flex justify-content-end mt-3">
                <button id="NewAccount" :disabled="saving" class="btn btn-primary btn-block themed-button">
                  <span v-if="!saving">{{ $t("lang.button.register") }}</span>
                  <span v-if="saving" class="loadingres mr-1 ml-1 spinner-border loading-spinner text-white"></span>
                </button>
              </div>
            </form>
          </div>
          <div class="col-12" v-if="showVerificationCode && !emailSent() && !calledFromAdmin">
            <div class="row d-flex flex-row justify-content-center">
              <div class="col-12 mt-3 text-center">
                <span class="mb-4">
                  <router-link to="/login" class="nav-link pxmd-0 px-2">
                    {{ $t("lang.label.if-you-have-account") }}
                    <span class="text-primary">{{
                      $t("lang.button.connect")
                      }}</span>
                  </router-link>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Component Booker Features -->
      <bdrFeatures v-if="!calledFromAdmin" />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import AlertError from "@/components/AlertError.vue";
import bdrFeatures from "@/components/AccountCreation/Steps/bookerFeatures.vue";
import {
  clientsService,
} from "@/_services";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Logo from "@/assets/images/logo-h.png";
import $ from "jquery";

export default {
  computed: {
    user() {
      return this.$store.state.authentication.user;
    },
    ...mapState({
      emailConfirmed: (state) => state.authentication.status.emailVerified,
      creating: (state) => state.authentication.creatingAccount,
      industry: (state) => state.optionsList.all["categories_google_all"].data,
      Countries: (state) => state.optionsList.all["profile_countries"].data,
      Languages: (state) => state.optionsList.all["languages"].data,
    }),
    flag() {
      const flag = this.flags.find((el) => el.id === this.language_id).text;
      return require("@/assets/images/flags/" + flag);
    },
    flag2() {
      return (countryId) => {
        const flag = this.countries.find((el) => el.id === countryId).iso;
        return require("@/assets/images/flags/" + flag + ".svg");
      };
    },
    alert() {
      return this.$store.state.alert;
    },
    userEmail() {
      const userEmail =
        this.usersame == "" || this.usersame == undefined
          ? this.$store.state.authentication.user.username
          : this.usersame;
      return userEmail;
    },
    creatingAccount() {
      return this.$store.state.authentication.creatingAccount;
    },
  },
  props: {
    calledFromAdmin: {
      type: Boolean,
      default: false,
    },
    referrer_id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      lastwebsite: "",
      tokencaptcha: "",
      saving: false,
      checkAgree: null,
      checkPolicy: null,
      countriesFiltered: [],
      filterCountry: null,
      flagActually: null,
      showFlag: true,
      optionsDefault: ["CA", "ES", "IT", "GB", "US", "FR", "DE"],
      countries: [],
      codeSent: false,
      validatePassword: {
        lowercase: false,
        uppercase: false,
        number: false,
        long: false,
      },
      flags: [
        { id: "1", text: "fr.svg" },
        { id: "2", text: "us.svg" },
        { id: "3", text: "es.svg" },
        { id: "4", text: "it.svg" },
        { id: "5", text: "pt.svg" },
      ],
      submittedCode: false,
      submittedCodeSecond: false,
      submittedData: false,
      submittedDataSecond: false,
      codepromo: "",
      referred: "",
      errors: [],
      lastname: "",
      firstname: "",
      user_bdr_origin_id: "",
      country_id_selected: "",
      working_hours_availability: "",
      has_bank_account: "",
      has_internet: "",
      has_computer: "",
      phone: "",
      password: "",
      email: "",
      username: "",
      language_id: "1",
      country_id: {
        id: "73",
        name: "France",
        iso: "fr",
        phone_code: "33",
        visible: true,
      },
      confirmpass: "",
      code: null,
      clientId: null,
      hash: null,
      showVerificationCode: true,
      showClientParameters: false,
      param_5: null,
      langs: [],
      countriesSelected: [
        { id: 2, name: "Albania" },
        { id: 3, name: "Algeria" },
        { id: 18, name: "Bangladesh" },
        { id: 21, name: "Belgium" },
        { id: 23, name: "Benin" },
        { id: 34, name: "Burkina Faso" },
        { id: 36, name: "Cambodia" },
        { id: 37, name: "Cameroon" },
        { id: 47, name: "Colombia" },
        { id: 49, name: "Congo" },
        { id: 52, name: "Costa Rica" },
        { id: 53, name: "Cote D'Ivoire" },
        { id: 61, name: "Dominican Republic" },
        { id: 73, name: "France" },
        { id: 77, name: "Gabon" },
        { id: 80, name: "Germany" },
        { id: 99, name: "India" },
        { id: 100, name: "Indonesia" },
        { id: 105, name: "Italy" },
        { id: 110, name: "Kenya" },
        { id: 127, name: "Madagascar" },
        { id: 131, name: "Mali" },
        { id: 136, name: "Mauritius" },
        { id: 138, name: "Mexico" },
        { id: 144, name: "Morocco" },
        { id: 150, name: "Netherlands" },
        { id: 156, name: "Nigeria" },
        { id: 162, name: "Pakistan" },
        { id: 169, name: "Philippines" },
        { id: 176, name: "Romania" },
        { id: 188, name: "Senegal" },
        { id: 197, name: "South Africa" },
        { id: 199, name: "Spain" },
        { id: 200, name: "Sri Lanka" },
        { id: 211, name: "Thailand" },
        { id: 213, name: "Togo" },
        { id: 217, name: "Tunisia" },
        { id: 225, name: "United Kingdom" },
        { id: 232, name: "Viet Nam" }
      ],
    };
  },
  components: {
    treeselect: Treeselect,
    AlertError,
    bdrFeatures,
    Logo,
  },
  created() {
    if (!this.calledFromAdmin) {
      const script = document.createElement("script");
      script.src =
        "https://www.google.com/recaptcha/api.js?render=6LddgDIpAAAAAFit4k7NY6Yf0YcPwShB2sVmTpF7";
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }

    // Verificar si el evento ya se cargo
    if (
      !window.dataLayer ||
      !window.dataLayer.some(
        (item) => item.event === "Page_Creation_Compte_Ouverte"
      )
    ) {
      // Si el evento no está, cargarlo
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "Page_Creation_Compte_Ouverte",
      });
    }

    this.countries = this.Countries.map((el) => {
      return {
        ...el,
        iso: el.iso.toLowerCase(),
        visible: this.optionsDefault.includes(el.iso),
      }
    })
    this.countriesFiltered = this.countries;
    this.countryDefault()

    this.$store.dispatch("alert/clear");
    this.verifyHash();
    // this.getParametersOptions(5);
    this.langs = this.Languages;
    this.referred = this.$route.params.referred;
    var d = new Date();
    d.setTime(d.getTime() + 60 * 24 * 60 * 60 * 1000);
    var expires = "; expires=" + d.toGMTString();

    if (this.referred == undefined) {
      var match = document.cookie.match(new RegExp("(^| )referred=([^;]+)"));
      if (match && match[2]) {
        this.referred = match[2];
      }
    } else {
      document.cookie = "referred=" + this.referred + expires + "; path=/";
    }

    // esto lo quite dela linea 145: pattern="^(?=(.*[a-z]){1,})(?=(.*[A-Z]){1,})(?=(.*[0-9]){1,})(?=(.*[ !#$%&'()*+,-./:;<=>?@\[\\\]^_`{|}~]){1,}).{8,16}$"
  },
  watch: {
    filterCountry(newValue) {
      this.countriesFiltered = this.countries.map((e) => ({ ...e }));
      if (newValue.length > 2) {
        this.countriesFiltered = this.countriesFiltered.filter((e) =>
          e.name.toUpperCase().includes(newValue.toUpperCase())
        );
        this.countriesFiltered.forEach((e) => (e.visible = true));
      }
    },
    country_id(newValue, oldValue) {
      if (newValue.id === "3333") {
        this.flagActually = null;
        return;
      }

      //if(newValue.id != "3333"){
      const flag = this.countries.find((el) => el.id === newValue.id).iso;
      this.flagActually = require("@/assets/images/flags/" + flag + ".svg");
      this.showFlag = true;
      //}
    },
    emailConfirmed: function () {
      if (this.emailConfirmed) {
        if (this.clientId == null) {
          this.showClientParameters = true;
          this.showUserParameters = false;
          this.showVerificationCode = false;
        } else {
          this.showClientParameters = false;
          this.showUserParameters = false;
          this.showVerificationCode = false;
        }
      } else {
        this.showClientParameters = false;
        this.showUserParameters = false;
        this.showVerificationCode = true;
      }
    },
    firstname() {
      this.firstname = this.$sanitize(this.firstname);
    },
    lastname() {
      this.lastname = this.$sanitize(this.lastname);
    },
    phone() {
      this.phone = this.$sanitize(this.phone);
    },
    email() {
      this.email = this.$sanitize(this.email);
    },
    language_id() {
      this.language_id = this.$sanitize(this.language_id);
    },
    user_bdr_origin_id() {
      this.user_bdr_origin_id = this.$sanitize(this.user_bdr_origin_id);
    },
    country_id_selected() {
      this.country_id_selected = this.$sanitize(this.country_id_selected);
    },
    working_hours_availability() {
      this.working_hours_availability = this.$sanitize(this.working_hours_availability);
    },
    has_bank_account() {
      this.has_bank_account = this.$sanitize(this.has_bank_account);
    },
    has_internet() {
      this.has_internet = this.$sanitize(this.has_internet);
    },
    has_computer() {
      this.has_computer = this.$sanitize(this.has_computer);
    },
    username() {
      this.username = this.$sanitize(this.username);
    },
    password(newValue, oldValue) {
      if (newValue.length > 0) {
        if (newValue.length > 5 && newValue.length < 17) {
          this.validatePassword.long = true;
        } else {
          this.validatePassword.long = false;
        }

        if (/[0-9]/.test(newValue)) {
          this.validatePassword.number = true;
        } else {
          this.validatePassword.number = false;
        }

        if (/[a-z]/.test(newValue)) {
          this.validatePassword.lowercase = true;
        } else {
          this.validatePassword.lowercase = false;
        }

        if (/[A-Z]/.test(newValue)) {
          this.validatePassword.uppercase = true;
        } else {
          this.validatePassword.uppercase = false;
        }
      } else {
        this.validatePassword = {
          long: false,
          number: false,
          uppercase: false,
          lowercase: false,
        };
      }
    },
  },
  methods: {
    changeCountry(countryId) {
      this.country_id = this.countries.find((e) => e.id === countryId);
    },
    hasPermissions(perm) {
      //return false;
      if (this.$store.state.authentication.user) {
        return this.$store.getters["authentication/hasPermissions"](perm);
      } else {
        return false;
      }
    },
    countryDefault() {
      const flag = this.countries.find((el) => el.id == 73).iso;
      this.flagActually = require("@/assets/images/flags/" + flag + ".svg");
    },
    verifyHash() {
      if (this.$route.query.hash !== undefined) {
        this.hash = this.$route.query.hash;

        if (this.hash != null) {
          clientsService.verifyHash(this.$route.query.hash).then((result) => {
            if (result.client_id != null) {
              this.clientId = result.client_id;
            } else {
              this.clientId = "INVALID";
            }
          });
        } else {
          this.$router.push("/login");
        }
      }
    },
    handleSubmit(e) {
      if (!this.validAgree() && !this.hasPermissions("adminClients"))
        return false;

      this.submittedData
        ? (this.submittedDataSecond = true)
        : (this.submittedData = true);

      const { dispatch } = this.$store;

      let dataUser = {};
      dataUser.name = this.firstname;
      dataUser.lastname = this.lastname;
      dataUser.phone = `+${this.country_id.phone_code}-${this.phone}`;
      dataUser.email = this.username;
      dataUser.user_bdr_origin_id = this.user_bdr_origin_id;
      dataUser.country_id = this.country_id_selected;
      dataUser.working_hours_availability = this.working_hours_availability;
      dataUser.referred = this.referred;
      dataUser.referrer_id = this.referrer_id;
      dataUser.password = this.password;
      dataUser.username = this.username;
      dataUser.client_id = this.clientId;
      dataUser.language_id = this.language_id;

      if (this.checkForm()) {
        this.saving = true;

        dispatch("authentication/createBooker", { dataUser }).then((res) => {
          // Verifica si el evento ya se ha cargo
          if (
            !window.dataLayer ||
            !window.dataLayer.some(
              (item) => item.event === "Formulaire_Creation_Compte_Valide"
            )
          ) {
            // Si el evento no está presente, cargarlo
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "Formulaire_Creation_Compte_Valide",
            });
          }
          this.saving = false;
          this.$emit("closeModal");
          if (res.id && res.exist) {
            this.$swal({
              type: "error",
              icon: "error",
              title: "Oops...",
              text: "Client Already exist",
              html: `<p class='text-danger'>Client already exist</p>
                    <a href="/clients/${res.id}" target='_blank' class='text-primary'>${res.company_name}</a>`,
            });
          } else {
            this.$swal({
              type: "success",
              title: this.$t("lang.label.great"),
              text: this.$t("lang.label.datasavedsuccessfully"),
              showConfirmButton: false,
              timer: 1800,
            });
          }
        });
        this.$store.dispatch("alert/clear");
      }
    },
    validAgree() {
      return true;
      // if (this.checkAgree === null) this.checkAgree = false;
      // if (this.checkPolicy === null) this.checkPolicy = false;
      // if (this.checkAgree === false || this.checkPolicy === false) return false;
    },
    emailSent() {
      //return false;
      if (this.user !== null && this.user.verificationcode != null) {
        return true;
      }
      return this.$store.state.authentication.status.emailSent;
    },
    checkVerificationCode() {
      this.submittedCode
        ? (this.submittedCodeSecond = true)
        : (this.submittedCode = true);
      const { code, username, password, clientId } = this;
      const { dispatch } = this.$store;
      if (this.code) {
        dispatch("authentication/verificationcode", {
          code,
          username,
          password,
          clientId,
        }).then((result) => {
          this.$router.push("/login?successcode");
        });
      }
    },
    resendVerificationCode() {
      const { username } = this;
      const { dispatch } = this.$store;
      dispatch("authentication/resendVerificationCode", {
        username,
      }).then((result) => {
        this.codeSent = true;
        this.$swal({
          type: "success",
          title: this.$t("lang.label.great"),
          html: this.$t("lang.accountcreation.verificationcoderesend", {
            user_email: this.userEmail,
          }),
          showConfirmButton: true,
          timer: 10000,
        });
      });
    },
    checkForm: function (e) {
      this.errors = []; // Reinicia el array de errores
      this.alert.message = ""; // Reinicia el mensaje de error en el componente AlertError

      if (
        this.firstname &&
        this.lastname &&
        this.firstname &&
        this.user_bdr_origin_id &&
        this.country_id_selected &&
        this.working_hours_availability &&
        this.has_bank_account &&
        this.has_internet &&
        this.has_computer &&
        this.phone &&
        this.confirmpass &&
        this.username
      ) {
        if (this.has_bank_account == "0" || this.has_internet == "0" || this.has_computer == "0") {
          this.errors.push(this.$t("lang.label.booker-login-error"));
        }
        if (this.password != this.confirmpass || Object.values(this.validatePassword).includes(false)) {
          this.errors.push(this.$t("lang.validation.confirmpassword"));
        }
        if(this.phone.length < 6){
          this.errors.push(this.$t("lang.label.phone_invalid"));
        }

        if (this.errors.length > 0) {
          this.alert.message = "";
          this.alert.message = this.errors.join("<br>"); 
          return false;
        }

        return true;
      }

      this.errors.push(this.$t("lang.validation.must_complete"));
      if(this.alert.message > 0){
        this.alert.message = "";
      }
      this.alert.message = this.errors.join("<br>"); // Actualiza alert.message con los errores
      return false;
    },
    goToStep(step) {
      //tiene que ir gotostep(1)
      this.$emit("goToStep", step);
    },
  },
};
</script>
<style scoped>
/* .mt2em {
  margin-top: 4%;
} */
@media only screen and (max-width: 600px) {
  .mobile-100 {
    height: 100vh;
  }
}

@media (min-width: 992px) {
  .hv-md-100 {
    height: 100vh;
  }
}

@media (max-width: 991px) {
  .mymd-5 {
    margin-top: 2em;
    margin-bottom: 2em;
  }
}

@media (max-width: 767px) {
  .mbsm-2 {
    margin-bottom: 1.5em;
  }
}

.reqfield:after {
  content: "*";
  font-weight: 400;
  color: red;
  padding-left: 0.2em;
  font-size: 1em;
}

svg.vue-treeselect__option-arrow {
  display: none !important;
}

div.vue-treeselect__option-arrow-container {
  font-family: "icomoon" !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
}

div.vue-treeselect__option-arrow-container::before {
  content: "\f196";
  color: #5054EB;
}

.detail {
  background-color: #f8f9fa !important;
  color:rgb(28, 30, 151)
}

.logooliver {
  width: 140px;
}

.calendar {
  width: 300px;
}

.flag {
  width: 25px;
}

.flag2 {
  width: 12px;
}

.img-buss {
  width: 25px;
  height: 25px;
}

.border border-dark {
  border: 2px solid red;
}

.icon-feature {
  width: 32px;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
